module.exports = __webpack_public_path__ + "static/media/IMG_9879.5308191f.JPG";